import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useLeadChangeStep = (props: { onSuccess?: () => void } = {}) => {
  const qc = useQueryClient();

  return useMutation(
    async (data: {
      leadId: number;
      statusId: number;
      updateTimestamp: number;
      newLead?: boolean;
      reasonsId?: number | null;
      autoClosedLeadTask?: boolean;
    }) => {
      const res = await $api.post('/v1/lead/change-step', data);

      return res?.data?.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries([crmConstants.queryKeys.LEAD_FILTER_V2]);
        if (props.onSuccess) {
          props.onSuccess();
        }
      }
    }
  );
};
